export const ANONYMOUS_SESSION_KEYS = {
  HAS_STARTED_FUNNEL: 'hasStartedFunnel',
  LAST_MATCH_CLINIC_IDS: 'lastMatchClinicIds',
  CLICKED_MATCH_CLINIC_IDS: 'clickedMatchClinicIds',
  HAS_RECEIVED_MATCH: 'hasReceivedMatch',
};
